var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.2031,
    r: 15,
    fill: "#E7E6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2735 9.41498C9.9806 9.12209 9.50573 9.12209 9.21283 9.41498C8.91994 9.70788 8.91994 10.1827 9.21283 10.4756L13.9334 15.1962L9.21283 19.9168C8.91994 20.2097 8.91994 20.6845 9.21283 20.9774C9.50573 21.2703 9.9806 21.2703 10.2735 20.9774L14.9941 16.2569L19.7146 20.9774C20.0075 21.2703 20.4824 21.2703 20.7753 20.9774C21.0682 20.6845 21.0682 20.2097 20.7753 19.9168L16.0547 15.1962L20.7753 10.4756C21.0682 10.1827 21.0682 9.70788 20.7753 9.41498C20.4824 9.12209 20.0075 9.12209 19.7146 9.41498L14.9941 14.1355L10.2735 9.41498Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.71c67d5ce990e540a0f639c029280e63.svg";
export { ForwardRef as ReactComponent };